import api from '@/api'
export default {
    namespaced: true,
    state: {
        total:0,
        registerarr1:[],
        editdata:{},
        title:''
    },
    getters: {
    },
    mutations: {
        //存储用户信息
        SET_REGISTERLIST1: (state, obj) => {

            state.total = obj.total
            state.registerarr1=[...obj.data]
        },
        SET_EDITDATA: (state, obj) => {

            state.editdata={...obj}
        },
        SET_TITLE: (state, title) => {

            state.title=title
        },
        DEL_DATA: (state, index) => {
            state.registerarr1.splice(index,1)
        },

       
        CLEAR_REGISTERLIST1: (state) => {

            state.total = 0
            state.registerarr1=[]

        },


    },
    actions: {
        async getRegisterlist1({ commit },params={page:1}) {
            
            let {code,message,data}=await api.getregisterlist1(params)
            if (code == 200) {
                commit('SET_REGISTERLIST1', data);
           
                return data;
            } else {
                return Promise.reject(new Error(message));
            }
        },
    },
}